/**
 * @copyright NIIT Technologies Ltd. 2017-18.
 */
// Angular
import { NgModule, NgZone, Component, ElementRef, Renderer, Input, forwardRef, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
// Core
import { ControlComponent } from '../../core/component/control.component';
// JQX Widget
import { jqxLoaderComponent } from 'jqwidgets-framework/jqwidgets-ts/angular_jqxloader';

/**
 * Loader
 */

export class NgcLoaderComponent extends ControlComponent {
     autoOpen: any;
     html: any;
     isModal: any;
     imagePosition: any;
     rtl: any;
     text: any;
     textPosition: any;
     theme: any;
     width: any;
     height: any;
     autoCreate: boolean = true;

     jqxLoader: jqxLoaderComponent;

    /**
     * Initialize
     */
    constructor(private ngZone: NgZone, private elementRef: ElementRef, private rendererRef: Renderer) {
        super(ngZone, elementRef, rendererRef);
    }

    open($e) {
        this.jqxLoader.open();
    }

    close($e) {
        this.jqxLoader.close();
    }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'ngc-loader',
    template: `<jqxLoader #jqxLoader
                [autoOpen] = "autoOpen"
                [html] = "html"
                [isModal] = "isModal"
                [imagePosition] = "imagePosition"
                [rtl] = "rtl"
                [text] = "text"
                [textPosition] = "textPosition"
                [theme] = "theme"
                [width] = "width"
                [height] = "height">
                <ng-content></ng-content>
                </jqxLoader>`
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: NgZone, },
{type: ElementRef, },
{type: Renderer, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'autoOpen': [{ type: Input, args: ['autoOpen', ] },],
'html': [{ type: Input, args: ['html', ] },],
'isModal': [{ type: Input, args: ['isModal', ] },],
'imagePosition': [{ type: Input, args: ['imagePosition', ] },],
'rtl': [{ type: Input, args: ['rtl', ] },],
'text': [{ type: Input, args: ['text', ] },],
'textPosition': [{ type: Input, args: ['textPosition', ] },],
'theme': [{ type: Input, args: ['theme', ] },],
'width': [{ type: Input, args: ['width', ] },],
'height': [{ type: Input, args: ['height', ] },],
'autoCreate': [{ type: Input, args: ['auto-create', ] },],
'jqxLoader': [{ type: ViewChild, args: ['jqxLoader', ] },],
};
}

/**
 * Loader Module
 */

export class NgcLoaderModule {
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [CommonModule],
    exports: [NgcLoaderComponent],
    declarations: [NgcLoaderComponent, jqxLoaderComponent]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}
interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
